import axios from "axios";

const reportAPI = {
  getReport: (body, params) =>
    axios.post(`${window.env.SP_REPORTS_URL}MonthlyReport`, body, {
      params,
      responseType: "blob"
    }),
  getBODReport: (body, params) =>
    axios.post(`${window.env.REPORT_URL}/reports/API/BODReport`, body, {
      params,
      responseType: "blob"
    }),
  getCEOReport: (body, params) =>
    axios.post(`${window.env.REPORT_URL}/Reports/API/CEOReport`, body, {
      params,
      responseType: "blob"
    }),
  getSectorReport: (body, params) =>
    axios.post(`${window.env.REPORT_URL}/Reports/API/SectorReport`, body, {
      params,
      responseType: "blob"
    })
};

export default reportAPI;
